import { Module } from 'vuex';

import { Nullable, RootState } from 'frontend/types';
import { GiftsSuccess, GiftPurchaseApiInputs, GiftFulfilled } from 'frontend/types/payments';
import { getJson } from 'frontend/utils/ajax';

const giftsSuccess: Module<GiftsSuccess, RootState> = {
  namespaced: true,
  mutations: {
    setValue(state: GiftsSuccess, value: GiftsSuccess) {
      state.session_id = value.session_id;
      state.gift_fulfilled = value.gift_fulfilled;
    },
    toggleSubscriptionStatus(state: GiftsSuccess) {
      if (!state.gift_fulfilled) {
        return;
      }

      state.gift_fulfilled.subscribed_to_extra_emails =
        !state.gift_fulfilled.subscribed_to_extra_emails;
    },
  },
  actions: {
    async getPurchase(
      { commit, state },
      { router, sessionId }: GiftPurchaseApiInputs,
    ): Promise<void> {
      if (state.gift_fulfilled) {
        return;
      }

      const url = router.resolve({
        name: 'payments_gifts_success',
        query: { session_id: sessionId },
      }).href;
      const response = await getJson(url);

      // data is `any` here, sigh
      const data = response.results.payments_gifts_success;
      commit('setValue', data);
    },
  },
  getters: {
    sessionId: (state: GiftsSuccess): string => state.session_id,
    giftFulfilled: (state: GiftsSuccess): Nullable<GiftFulfilled> => state.gift_fulfilled,
  },
};

export default giftsSuccess;
